export const EMPTY_SMART_DOCUMENT = {
  type: 'doc',
  content: [
    {
      type: 'paragraph'
    }
  ]
};
